export default async function loadData() {
  // Paths to GeoJSONs
  // prettier-ignore
  const pathCountries = new URL("../data/CountriesSimplified.geojson", import.meta.url);
  // prettier-ignore
  const pathContinental = new URL("../data/Continental_BiomesSimplified.geojson", import.meta.url);
  // prettier-ignore
  const pathEcoregions = new URL("../data/EcoregionsSimplified.geojson", import.meta.url);
  // prettier-ignore
  const pathGADM = new URL("../data/GADM_UCDavis_L1Simplified.geojson", import.meta.url);

  const [countries, biomes, ecoregions, gadm] = await Promise.all([
    fetch(pathCountries).then((res) => res.json()),
    fetch(pathContinental).then((res) => res.json()),
    fetch(pathEcoregions).then((res) => res.json()),
    fetch(pathGADM).then((res) => res.json()),
  ]);

  // Return promises
  return [countries, biomes, ecoregions, gadm];
}
